import { StyleParamType, wixColorParam, wixFontParam, createStylesParams } from '@wix/tpa-settings';
import { TEXT_ALIGNMENT_VALUES, PREVIEW_TYPES, LAYOUT_STYLE_VALUES, MAIN_ACTION_STYLE_TYPES, LOAD_MORE_BUTTON_TYPE_VALUES, PLAY_TYPE_VALUES, CHANNEL_LAYOUT_VALUES, EXPANDED_THEME_VALUES, MAIN_ITEM_TYPE_VALUES, INFO_POSITION_VALUES, CHANNEL_VIDEO_LIST_VALUES, VIDEO_END_OPTIONS, THUMBNAIL_BUTTONS_BEHAVIOR, SHOW_MEDIA_TYPE_VALUES, SHOW_INFO_VALUES, SHOW_EXPANDED_VIDEO_LIST_INFO_VALUES, APP_SETTINGS_VERSION_LATEST, NAVIGATION_ARROWS_POSITION, TITLE_POSITION_VALUES, NAVIGATION_ARROWS_BEHAVIOR, COMPACT_SHOW_VIDEO_LIST_VALUES, THUMBNAIL_SPACING_PRESETS, THUMBNAIL_SPACING_VALUE_PER_PRESET, MOBILE_CHANNEL_LAYOUT_VALUES } from '.';
const getLayout = params => {
  const layout = params.getStyleParamValue(stylesParams.channelLayout);
  const isSmallSlider = layout === CHANNEL_LAYOUT_VALUES.SLIDER_SMALL;
  const isBigSlider = layout === CHANNEL_LAYOUT_VALUES.SLIDER_BIG;
  return {
    layout,
    isClassic: layout === CHANNEL_LAYOUT_VALUES.CLASSIC,
    isCompact: layout === CHANNEL_LAYOUT_VALUES.COMPACT,
    isGrid: layout === CHANNEL_LAYOUT_VALUES.GRID,
    isSmallSlider,
    isBigSlider,
    isStrip: layout === CHANNEL_LAYOUT_VALUES.STRIP,
    isSlider: isBigSlider || isSmallSlider
  };
};
export const getDefaultNumberOfRows = _ref => {
  let {
    isGrid
  } = _ref;
  return isGrid ? 3 : 1;
};
export const getDefaultVideosInRow = _ref2 => {
  let {
    isGrid
  } = _ref2;
  return isGrid ? 3 : 4;
};
export const stylesParams = createStylesParams({
  // Colors
  backgroundColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-1')
  },
  textColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5')
  },
  buttonsAndLinksColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-8')
  },
  mainButtonColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-8')
  },
  mainButtonTextColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-1')
  },
  mobileChannelLayout: {
    type: StyleParamType.Number,
    getDefaultValue: () => MOBILE_CHANNEL_LAYOUT_VALUES.COMPACT
  },
  mobileMenuTextColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-1')
  },
  mobileMenuBackgroundColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5')
  },
  thumbnailButtonsColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-1')
  },
  mobileButtonsTextColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-1')
  },
  mobileButtonsBackgroundColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-1')
  },
  dividersAndArrowsColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-3')
  },
  emptyPlayIconEditor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-4')
  },
  emptyPlayIconSite: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-1')
  },
  emptyPlayerBgEditor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-2')
  },
  emptyPlayerBgSite: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-2')
  },
  compactMenuBackgroundColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5')
  },
  compactMenuActionsColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-1')
  },
  thumbnailOverlayColor: {
    type: StyleParamType.Color,
    getDefaultValue: () => ({
      name: 'thumbnailOverlayColor',
      value: 'rgba(0, 0, 0, 0.4)',
      opacity: 0.4
    })
  },
  // Fonts
  textFont: {
    type: StyleParamType.Font,
    getDefaultValue: wixFontParam('Body-S')
  },
  titleFont: {
    type: StyleParamType.Font,
    getDefaultValue: wixFontParam('Heading-S')
  },
  videoInfoFont: {
    type: StyleParamType.Font,
    getDefaultValue: wixFontParam('Heading-S')
  },
  // @deprecated use channelId from settingsParams
  channelId: {
    type: StyleParamType.Font
  },
  // @deprecated use videoId from settingsParams
  videoId: {
    type: StyleParamType.Font
  },
  // Numbers
  channelLayout: {
    type: StyleParamType.Number,
    getDefaultValue: _ref3 => {
      let {
        isEditorX
      } = _ref3;
      return isEditorX ? CHANNEL_LAYOUT_VALUES.SLIDER_SMALL : CHANNEL_LAYOUT_VALUES.CLASSIC;
    }
  },
  compactShowVideoListType: {
    type: StyleParamType.Number,
    getDefaultValue: () => COMPACT_SHOW_VIDEO_LIST_VALUES.EXPAND_ON_CLICK
  },
  containerMargins: {
    type: StyleParamType.Number,
    getDefaultValue: params => {
      const {
        isGrid
      } = getLayout(params);
      return isGrid ? 60 : 0;
    }
  },
  expandedTheme: {
    type: StyleParamType.Number,
    getDefaultValue: () => EXPANDED_THEME_VALUES.DARK
  },
  layoutStyle: {
    type: StyleParamType.Number,
    getDefaultValue: () => LAYOUT_STYLE_VALUES.SQUARE
  },
  loadMoreButtonType: {
    type: StyleParamType.Number,
    getDefaultValue: () => LOAD_MORE_BUTTON_TYPE_VALUES.TEXT
  },
  mainActionStyleType: {
    type: StyleParamType.Number,
    getDefaultValue: params => {
      const {
        isSmallSlider
      } = getLayout(params);
      if (params.isEditorX) {
        return MAIN_ACTION_STYLE_TYPES.ICON_WITH_TEXT;
      }
      return isSmallSlider ? MAIN_ACTION_STYLE_TYPES.ICON : MAIN_ACTION_STYLE_TYPES.ICON_WITH_TEXT;
    }
  },
  mainItemOverlayOpacity: {
    type: StyleParamType.Number,
    getDefaultValue: _ref4 => {
      let {
        isEditorX
      } = _ref4;
      return isEditorX ? 40 : 35;
    }
  },
  mainItemTitlePosition: {
    type: StyleParamType.Number,
    getDefaultValue: () => TITLE_POSITION_VALUES.CENTER
  },
  mainItemType: {
    type: StyleParamType.Number,
    getDefaultValue: () => MAIN_ITEM_TYPE_VALUES.CHANNEL_COVER
  },
  navigationArrowsBehavior: {
    type: StyleParamType.Number,
    getDefaultValue: params => {
      const {
        isSmallSlider
      } = getLayout(params);
      return isSmallSlider ? NAVIGATION_ARROWS_BEHAVIOR.ALWAYS : NAVIGATION_ARROWS_BEHAVIOR.ON_HOVER;
    }
  },
  navigationArrowsPosition: {
    type: StyleParamType.Number,
    getDefaultValue: params => {
      const {
        isSmallSlider
      } = getLayout(params);
      if (params.isEditorX) {
        return NAVIGATION_ARROWS_POSITION.INSIDE;
      }
      return isSmallSlider ? NAVIGATION_ARROWS_POSITION.OUTSIDE : NAVIGATION_ARROWS_POSITION.INSIDE;
    }
  },
  numberOfRows: {
    type: StyleParamType.Number,
    getDefaultValue: params => {
      const {
        isGrid
      } = getLayout(params);
      return getDefaultNumberOfRows({
        isGrid
      });
    }
  },
  playType: {
    type: StyleParamType.Number,
    getDefaultValue: params => {
      const {
        isClassic,
        isCompact
      } = getLayout(params);
      return isClassic || isCompact ? PLAY_TYPE_VALUES.IN_FRAME : PLAY_TYPE_VALUES.EXPANDED_VIEW;
    }
  },
  previewType: {
    type: StyleParamType.Number,
    getDefaultValue: () => PREVIEW_TYPES.NONE
  },
  settingsVersion: {
    type: StyleParamType.Number,
    getDefaultValue: () => APP_SETTINGS_VERSION_LATEST
  },
  showExpandedVideoListInfo: {
    type: StyleParamType.Number,
    getDefaultValue: () => SHOW_EXPANDED_VIDEO_LIST_INFO_VALUES.ON_MOUSE_OVER
  },
  showInfoAction: {
    type: StyleParamType.Number,
    getDefaultValue: () => SHOW_INFO_VALUES.ON_MOUSE_OVER
  },
  showMediaType: {
    type: StyleParamType.Number,
    getDefaultValue: () => SHOW_MEDIA_TYPE_VALUES.COVER_IMAGE
  },
  /** @deprecated The height is automatically adjusted to the content (fitToContentHeight: true) */
  sliderHeight: {
    type: StyleParamType.Number,
    getDefaultValue: params => {
      const {
        isSmallSlider
      } = getLayout(params);
      return isSmallSlider ? 388 : 572;
    }
  },
  textAlignment: {
    type: StyleParamType.Number,
    getDefaultValue: params => {
      const {
        isBigSlider
      } = getLayout(params);
      return isBigSlider ? TEXT_ALIGNMENT_VALUES.CENTER : TEXT_ALIGNMENT_VALUES.LEFT;
    }
  },
  thumbnailButtonsBehavior: {
    type: StyleParamType.Number,
    getDefaultValue: params => {
      const {
        isSmallSlider
      } = getLayout(params);
      if (params.isEditorX) {
        return THUMBNAIL_BUTTONS_BEHAVIOR.ON_HOVER;
      }
      return isSmallSlider ? THUMBNAIL_BUTTONS_BEHAVIOR.ALWAYS : THUMBNAIL_BUTTONS_BEHAVIOR.ON_HOVER;
    }
  },
  thumbnailOverlayOpacity: {
    type: StyleParamType.Number,
    getDefaultValue: () => 40
  },
  thumbnailSpacing: {
    type: StyleParamType.Number,
    getDefaultValue: params => {
      const {
        isBigSlider
      } = getLayout(params);
      if (params.isEditorX) {
        return THUMBNAIL_SPACING_VALUE_PER_PRESET[THUMBNAIL_SPACING_PRESETS.NARROW];
      }
      if (isBigSlider) {
        return 30;
      }
      return 0;
    }
  },
  videoEndOption: {
    type: StyleParamType.Number,
    getDefaultValue: () => VIDEO_END_OPTIONS.SHOW_VIDEO_COVER
  },
  videoInfoPosition: {
    type: StyleParamType.Number,
    getDefaultValue: () => INFO_POSITION_VALUES.ON_VIDEOS
  },
  videoListVisibility: {
    type: StyleParamType.Number,
    getDefaultValue: () => CHANNEL_VIDEO_LIST_VALUES.EXPAND_ON_CLICK
  },
  videosInRow: {
    type: StyleParamType.Number,
    getDefaultValue: params => {
      const {
        isGrid
      } = getLayout(params);
      return getDefaultVideosInRow({
        isGrid
      });
    }
  },
  // Booleans
  responsive: {
    // this property is provided by the platform
    type: StyleParamType.Boolean,
    getDefaultValue: () => false
  },
  allowComments: {
    type: StyleParamType.Boolean,
    getDefaultValue: () => false
  },
  allowCommentsLive: {
    type: StyleParamType.Boolean,
    getDefaultValue: () => false
  },
  showTitleForMainItem: {
    type: StyleParamType.Boolean,
    getDefaultValue: () => true
  },
  showPublisherForMainItem: {
    type: StyleParamType.Boolean,
    getDefaultValue: () => true
  },
  showChannelTitle: {
    type: StyleParamType.Boolean,
    getDefaultValue: () => true
  },
  showChannelShare: {
    type: StyleParamType.Boolean,
    getDefaultValue: () => true
  },
  showChannelInfo: {
    type: StyleParamType.Boolean,
    getDefaultValue: () => false
  },
  showChannelCategories: {
    type: StyleParamType.Boolean,
    getDefaultValue: () => true
  },
  showSearch: {
    type: StyleParamType.Boolean,
    getDefaultValue: () => true
  },
  showChannelTags: {
    type: StyleParamType.Boolean,
    getDefaultValue: () => true
  },
  showVideoTitle: {
    type: StyleParamType.Boolean,
    getDefaultValue: () => true
  },
  showFullInfo: {
    type: StyleParamType.Boolean,
    getDefaultValue: () => true
  },
  enableVideosSharing: {
    type: StyleParamType.Boolean,
    getDefaultValue: () => true
  },
  autoPlay: {
    type: StyleParamType.Boolean,
    getDefaultValue: () => false
  },
  showSignIn: {
    type: StyleParamType.Boolean,
    getDefaultValue: () => true
  },
  showVideoTitleInList: {
    type: StyleParamType.Boolean,
    getDefaultValue: () => true
  },
  showVideoPublisherInList: {
    type: StyleParamType.Boolean,
    getDefaultValue: () => false
  },
  showVideoDurationInList: {
    type: StyleParamType.Boolean,
    getDefaultValue: () => true
  },
  showVideoDescriptionInList: {
    type: StyleParamType.Boolean,
    getDefaultValue: () => true
  },
  showExpandedChannelTitle: {
    type: StyleParamType.Boolean,
    getDefaultValue: () => false
  },
  showExpandedVideoInfo: {
    type: StyleParamType.Boolean,
    getDefaultValue: () => true
  },
  showExpandedSignIn: {
    type: StyleParamType.Boolean,
    getDefaultValue: () => false
  },
  stretchToFullWidth: {
    type: StyleParamType.Boolean,
    getDefaultValue: params => {
      const {
        isGrid,
        isSlider,
        isStrip
      } = getLayout(params);
      return isGrid || isSlider || isStrip;
    }
  },
  enableExpandedVideosSharing: {
    type: StyleParamType.Boolean,
    getDefaultValue: () => true
  },
  showExpandedVideoList: {
    type: StyleParamType.Boolean,
    getDefaultValue: () => true
  },
  useOptimalFontSizes: {
    type: StyleParamType.Boolean,
    getDefaultValue: () => false
  },
  showVideoQuality: {
    type: StyleParamType.Boolean,
    getDefaultValue: () => true
  },
  showVideoPlaybackSpeed: {
    type: StyleParamType.Boolean,
    getDefaultValue: () => true
  }
});
//# sourceMappingURL=stylesParams.js.map